'use strict';
var _ = require('lodash');
var Backbone = require('backbone');
var PubSub = require('tscom-pubsub');
var template = require('../../templates/voteoption.ejs');

module.exports = Backbone.View.extend({
    className: 'view-voteoption',
    events: {
        'click .minus': 'minusVote',
        'click .plus': 'plusVote',
        'click .facebook-share': 'fbShare',
        'click .twitter-follow-button': 'twitterFollow',
        'click .instagram-follow-button': 'instagramFollow',
        'click .twitter-share': 'twitterShare'
    },
    /**
     * Initialize Vote Option View
     */
    initialize: function (options) {
        _.bindAll(this, 'render', 'renderVoteCount' );
        this.type = options.type;
        this.copyCms = options.copyCms;
        this.optionsList = options.optionsList;
        this.maxVote = this.model.get('maxVotes');
        this.userModel = (typeof options.userModel !== 'undefined') ?
            options.userModel : null;

        if(!this.type) {
            // add the vote count listener only if we are loading the vote options in the grid view
            this.listenTo(this.model, 'change:voteCount', this.renderVoteCount );
        }
        
        this.setCopyModels();
        this.listenTo(this.copyCms, 'change:language', function() {
            this.setCopyModels();

            this.render();
        }.bind(this));
    },
    setCopyModels: function() {
        switch( this.type ) {
        case 'thanks':
            this.textModel = this.copyCms.get('text').views_thanks;
            break;
        case 'confirm':
            this.textModel = this.copyCms.get('text').views_vote_confirmation;
            break;
        default:
            this.textModel = this.copyCms.get('text').views_vote_grid;
            break;
        }
        
        this.copy = this.copyCms.get('text').views_vote_option;

    },

    /**
     * Render vote count
     */
    renderVoteCount: function () {
        var voteCount = this.model.get('voteCount');
        var votes = this.formatVoteCopy(voteCount);

        this.updateVotes(votes);

        if(this.model.get('voteCount') > 0){
            this.$el.find('.voting').addClass('active');
        } else {
            this.$el.find('.voting').removeClass('active');
        }

        this.$('.minus').attr('aria-disabled', this.isButtonDisabled('MINUS'));
        this.$('.plus').attr('aria-disabled', this.isButtonDisabled('PLUS'));

        this.updateButtonLabel(voteCount);
    },
    /**
     * Render Vote Option View
     */
    render: function () {
        var model = _.extend(_.clone(this.model.toJSON()),{
            formattedVotes: this.formatVoteCopy(this.model.get('voteCount')),
            type: this.type,
            textModel: this.textModel
        });
        const names = model.name.trim().split(' & ');
        model.formattedName = model.name.trim();
        model.contestant1 = names[0].trim(); // Celebrity
        model.contestant2 = names[1].trim(); // Professional

        if(this.type=='thanks') {
            var text = this.textModel.share.twitter;
            var contestant1 = model.twitter_handle_1.length > 0 ? model.twitter_handle_1 : names[0].trim();
            var contestant2 = model.twitter_handle_2.length > 0 ? model.twitter_handle_2 : names[1].trim();
            text = text.replace('{{CONTESTANT1}}', contestant1).replace('{{CONTESTANT2}}', contestant2).replace('{{HASHTAG}}', model.hashtag);
            model.twitterShare = 'https://twitter.com/intent/tweet?text='+encodeURIComponent(text);
            model = _.extend(_.clone(this.textModel), model);
        }

        this.$el.html(template(model));

        this.renderVoteCount();

        return this;
    },
    /**
     * [minusVote description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    minusVote: function() {
        if (this.isButtonDisabled('MINUS')) {

            return false;
        }

        if(this.userModel && this.userModel.isConnected() && this.userModel.isVerified()) {
            if(this.model.get('voteCount') > 0) {
                PubSub.trigger('omniture:action','removeVoteClick','Remove Vote');

                var votes = this.model.get('voteCount') - 1;
                this.model.set('voteCount', votes);

                this.updateVoteLabel(votes);
            }
        } else {
            PubSub.trigger('launchLogin', this.minusVote.bind(this));
        }
    },
    /**
     * [plusVote description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    plusVote: function() {
        if (this.isButtonDisabled('PLUS')) {
            return false;
        }

        if (this.userModel && this.userModel.isConnected() && this.userModel.isVerified()) {
            if (this.model.get('voteCount') < this.maxVote
                && this.optionsList.getTotal() < this.optionsList.maxVotes ) {

                PubSub.trigger('omniture:action','addVoteClick','Add Vote');

                var votes = this.model.get('voteCount') + 1;
                this.model.set('voteCount', votes);

                this.updateVoteLabel(votes);

            }
        } else {
            PubSub.trigger('launchLogin', this.plusVote.bind(this));
        }
    },

    updateButtonLabel: function (votes) {
        const minusRemainingLabel = this.copy.minus_button_a11y.
            replace('{{NAME}}', this.model.get('name')).
            replace('{{VOTES}}', votes);
        const minusZeroLabel = this.copy.minus_button_a11y_zero;

        const plusRemainingLabel = this.copy.plus_button_a11y.
            replace('{{NAME}}', this.model.get('name')).
            replace('{{VOTES}}', votes);
        const plusZeroLabel = this.copy.plus_button_a11y_zero;


        const minusButtonLabel = votes > 0
            ? minusRemainingLabel
            : minusZeroLabel;

        const plusButtonLabel = votes < this.maxVote
            ? plusRemainingLabel
            : plusZeroLabel;

        this.$('button.minus').attr('aria-label', minusButtonLabel);
        this.$('button.plus').attr('aria-label', plusButtonLabel);
    },

    updateVotes: function(votes) {
        this.$('.vote-count .votes').html(votes);
    },

    updateVoteLabel: function(votes) {
        const voteLabel = this.$el.find('.vote-count-label');
        const labelCopy = this.copy.vote_count_label.replace('{{VOTES}}', votes);

        voteLabel.html(labelCopy);
        voteLabel.hide();
        voteLabel.show();

        setTimeout(function() {
            voteLabel.empty();
        }, 300);
    },

    formatVoteCopy: function(vote) {
        const votesWord = vote === 1 ? this.textModel.vote : this.textModel.votes;
        const votesPreposition = this.copyCms.get('text').views_vote_option.vote_count_preposition;
        switch(this.type) {

        case 'confirm':
        case 'thanks':
            return `${vote} ${votesWord}`;
        default:
            return `${vote} ${votesPreposition} ${this.maxVote}`;
        }

    },

    /**
     * [fbShare description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    fbShare: function(e) {
        e.preventDefault();

        var contestantId = this.model.get( 'id' );

        PubSub.trigger('facebookShare', {
            id: contestantId
        });

        PubSub.trigger('omniture:action','facebookShare','Facebook Share Contestant');
    },
    /**
     * [twitterFollow description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    twitterFollow: function(e) {
        e.preventDefault();
        PubSub.trigger('omniture:action','twitterFollow','Twitter Follow');
        window.open(e.currentTarget.dataset['href'],'targetWindow',
            'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=400px,height=500px');
    },
    /**
     * [instagramFollow description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    instagramFollow: function(e) {
        e.preventDefault();
        PubSub.trigger('omniture:action','instagramFollow','Instagram Follow');
        window.open(e.currentTarget.dataset['href'], '_blank');
    },
    /**
     * [twitterShare description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    twitterShare: function( e ){
        e.preventDefault();
        var url = e.currentTarget.getAttribute( 'data-href' );
        window.open( url, '_blank', 'width=400px,height=400px' );

        PubSub.trigger('omniture:action','twitterShare','Twitter Share Contestant');
    },
    isButtonDisabled: function (buttonType) {
        var voteCount = this.model.get('voteCount');

        switch (buttonType) {
        case 'PLUS':
            return voteCount == this.maxVote || this.optionsList.getTotal() == this.optionsList.maxVotes;
        case 'MINUS':
            return voteCount === 0;

        }
    }
});



// WEBPACK FOOTER //
// ./app/scripts/common/views/voteoption.js